module.exports = __webpack_public_path__ + "img/MPS_DM.159ba07d.png";